// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/app-" + chunkId + "." + {"2416":"32624b05","4121":"34376a73","7228":"06ceb0cd","9198":"7a29d50e"}[chunkId] + ".chunk.css";
};